import React, { useState, useEffect } from 'react';
import styles from "./styles.module.css";
import DatabaseService from "../services/database.service.js";

import DeviceModalSettings from './devices/DeviceModalSettings';
import DeviceModalLogs from './devices/DeviceModalLogs';
import DeviceModalMessageView from './devices/DeviceModalMessageView';
import BackendService from "../services/backend.service.js";
import {
  MAINTENANCE_CODE_CURRENT, MAINTENANCE_CODE_LVL1,
  MAINTENANCE_CODE_LVL2,
  MAINTENANCE_CODE_LVL10
} from "../common/Settings.js";

import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarExport,
  GridToolbarQuickFilter
} from '@mui/x-data-grid';

import EventBus from "../common/EventBus";

import AuthService from "../services/auth.service";

import { convertDateToString } from '../common/ConvertTools.js'
import { ToastContainer, toast } from 'react-toastify';

import gridSxStyle from "../common/GridSxStyles.js";

import '../services/isMobile.js'

const BoardDevices = () => {
  const [devices, setDevices] = useState("");
  const [firmwares, setFirmwares] = useState("");

  const DEFAULT_SORT_MODEL = [{ field: 'date_app_cnx', sort: 'desc' }];
  const storedSortModel = localStorage.getItem('devicesSortModel');
  const initialSortModel = storedSortModel ? JSON.parse(storedSortModel) : DEFAULT_SORT_MODEL;
  const [devicesSortModel, setDevicesSortModel] = useState(initialSortModel);

  const DEFAULT_PAGINATION_MODEL = [{ page: 0, pageSize: 45 }];
  const storedPaginationModel = localStorage.getItem('devicesPaginationModel')
  const initialPaginationModel = storedPaginationModel ? JSON.parse(storedPaginationModel) : DEFAULT_PAGINATION_MODEL;
  const [devicesPaginationModel, setDevicesPaginationModel] = useState(initialPaginationModel);

  const currentUser = AuthService.getCurrentUser();
  const isAdmin = currentUser.roles.includes("admin_smart")
  const isPartner = currentUser.roles.includes("partner")

  const isDesktop = (!window.mobileCheck()) // || isNarrowScreen

  const [isModalSettingsOpen, setModalSettingsOpen] = useState(false);
  const [isModalLogsOpen, setModalLogsOpen] = useState(false);
  const [isModalMsgViewOpen, setModalMsgViewOpen] = useState(false)

  const handleCloseSettingsModal = () => setModalSettingsOpen(false);
  const handleCloseLogsModal = () => setModalLogsOpen(false);

  const [selectedDevice, setSelectedDevice] = useState(null);

  let toastId = null;
  let minToastDuration = 1500; // Minimum toast display time in milliseconds


  const showToast = () => {
    toastId = toast.loading("Refreshing", {
      position: "bottom-right",
      autoClose: false, // Prevent auto-close to manually control the duration
    });
  };

  const TableToolbar = (props) => {
    return (
      <GridToolbarContainer>

        <button className="MuiButtonBase-root MuiButton-root MuiButton-text MuiButton-textPrimary MuiButton-sizeSmall MuiButton-textSizeSmall MuiButton-root MuiButton-text MuiButton-textPrimary MuiButton-sizeSmall MuiButton-textSizeSmall MuiCustomButton"
          onClick={() => {

            showToast();
            loadDevices();

          }}>
          <i className="fa-solid fa-arrows-rotate" style={{ color: 'var(--color-foreground)', marginRight: '8px' }}></i>
          Refresh
        </button>

        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarExport />
        <GridToolbarQuickFilter />
      </GridToolbarContainer>
    );
  };


  const loadDevices = () => {

    const startTime = Date.now();

    DatabaseService.getFirmwares().then((response) => {
      setFirmwares(response.data)

      DatabaseService.getDevices().then(
        (response) => {
          setDevices(response.data);

          const loadDuration = Date.now() - startTime;
          const displayDuration = Math.max(minToastDuration, loadDuration);

          setTimeout(() => {
            toast.dismiss(toastId);
          }, displayDuration);

          console.log("response.data", JSON.stringify(response.data[0]));
        },
        (error) => {
          if (error.response && error.response.status === 401) {
            EventBus.dispatch("logout");
          }
        }
      );
    }, (error) => {
      console.error(error);
    })

  }

  useEffect(() => {

    loadDevices()

  }, []);


  function convertVersionToString(version) {

    let formattedDate = "";

    // TODO : convert epoch date to string in "yyyy/MM/dd HH:MM" format
    if (version === undefined || version === 0 || isNaN(version))
      return ""

    return version;
  }

  const handleOpenSettingsModal = (deviceProps) => {
    console.log("handleOpenSettingsModal", deviceProps);
    setSelectedDevice(deviceProps);
    setModalSettingsOpen(true);
  };

  const handleOpenLogsModal = (deviceProps) => {
    console.log("handleOpenLogsModal", deviceProps);
    setSelectedDevice(deviceProps);
    setModalLogsOpen(true);
  };

  const handleOpenMsgViewModal = async (deviceProps) => {
    console.log("handleOpenMsgViewModal", deviceProps);

    const deviceSettings = await BackendService.getSettingsDevice(deviceProps?.mac_custom)
    if (deviceSettings.status !== 200) {
      deviceProps.maintenanceLevel = 'unknown'
    } else {
      const maintenanceLevel1 = deviceSettings.data.enrichedSettings.find(setting => setting.bleId === MAINTENANCE_CODE_LVL1)
      const maintenanceLevel2 = deviceSettings.data.enrichedSettings.find(setting => setting.bleId === MAINTENANCE_CODE_LVL2)
      const maintenanceLevel10 = deviceSettings.data.enrichedSettings.find(setting => setting.bleId === MAINTENANCE_CODE_LVL10)
      const maintenanceLevelCurrent = deviceSettings.data.enrichedSettings.find(setting => setting.bleId === MAINTENANCE_CODE_CURRENT)
      if (maintenanceLevelCurrent?.value === maintenanceLevel1?.value) {
        deviceProps.maintenanceLevel = 1
      } else if (maintenanceLevelCurrent?.value === maintenanceLevel2?.value) {
        deviceProps.maintenanceLevel = 2
      } else if (maintenanceLevelCurrent?.value === maintenanceLevel10?.value) {
        deviceProps.maintenanceLevel = 10
      }
    }

    setSelectedDevice(deviceProps);

    setModalMsgViewOpen(true);
  };



  const handleSortModelChange = (sortModel) => {
    console.log("handleSortModelChange");

    setDevicesSortModel(sortModel);
    localStorage.setItem('devicesSortModel', JSON.stringify(sortModel));

  }

  const handlePaginationModelChange = (paginationModel) => {
    console.log("handlePaginationModelChange");

    setDevicesPaginationModel(paginationModel);
    localStorage.setItem('devicesPaginationModel', JSON.stringify(paginationModel));
  }

  const onMessageDelete = async (id) => {
    console.log("onMessageDelete", id);
    const response = await DatabaseService.removeMsg(id)

    if (response.status == 204) {
      return 1
    }
    else {
      return -1
    }

  }

  const onUpdateDeviceMsgs = (selectedDevice) => {

    const updatedRows = devices.map((item) => {
      if (item.id === selectedDevice.id) {
        return {
          ...item,
          msg_devices_push: selectedDevice.msg_devices_push
        };
      }
      return item;
    });
    setDevices(updatedRows); // Update the state
  }

  const processRowUpdate = React.useCallback(
    async (newRow) => {
      console.log("processRowUpdate", newRow);

      const response = await DatabaseService.editDeviceComment(newRow.id, newRow.comment);

      if (response.status == 204) {
        toast.success("Comment edited successfully", {
          position: "bottom-right",
          autoClose: 2000
        });

        // Update the state to reflect the comment change
        const updatedRows = devices.map((item) => {
          if (item.id === newRow.id) {
            return {
              ...item,
              comment: newRow.comment
            };
          }
          return item;
        });

        setDevices(updatedRows); // Update the state

      }
      else {
        toast.error("Error editing the comment", {
          position: "bottom-right",
          autoClose: 2000
        });
      }
      return response;
    },
  );

  const handleProcessRowUpdateError = React.useCallback((error) => {
    /*
    toast.error("Error editing the comment", {
      position: "bottom-right",
      autoClose: 2000
    });
    */
    console.log("handleProcessRowUpdateError", error);
  }, []);

  /*
  "mac_factory":"e8:9f:6d:6f:25:78","mac_custom":"e8:9f:6d:6f:25:78","user_id":"koxx3@free.fr","comment":"boosted","ble_name":"Boosted"}
  */
  const columns = [
    {
      field: 'actions', headerName: '',
      width: (isAdmin || isPartner) ? "90" : "30",
      resizable: false,
      renderCell: ({ row }) => (
        <div style={{ textAlign: 'center', marginTop: "1px" }}>
          <i className="fa fa-gear" onClick={() => { handleOpenSettingsModal(row) }}></i>
          {(isAdmin || isPartner) && <i className="fa fa-file-lines" style={{ paddingLeft: "15px" }} onClick={() => { handleOpenLogsModal(row) }}></i>}
          {(isAdmin || isPartner) && <i className="fa fa-message" style={{ paddingLeft: "15px" }} onClick={() => { handleOpenMsgViewModal(row) }}></i>}
        </div>
      )
    },
    {
      field: 'ble_name', headerName: 'Smart Name',
      width: "100",
      // flex: 1,
    },
    {
      field: 'user_id', headerName: 'Email',
      width: "250",
      // flex: 1,
    },
    {
      field: 'comment', headerName: 'Comment',
      flex: 1,
      minWidth: 150,
      hidden: true,
      editable: true,  // Make this column editable
    },
    {
      field: 'date_app_cnx', headerName: 'APP cnx',
      width: "150",
      // flex: 1,
      renderCell: ({ row }) => (<div>{convertDateToString(row.date_app_cnx)}</div>)
    },
    {
      field: 'version_app', headerName: 'APP version',
      width: "80",
      renderCell: ({ row }) => (<div>{convertVersionToString(row.version_app)}</div>)

      // flex: 1,
    },
    {
      field: 'date_flash', headerName: 'FW flash',
      width: "150",
      // flex: 1,
      renderCell: ({ row }) => (<div>{convertDateToString(row.date_flash)}</div>)
    },
    {
      field: 'date_reflash', headerName: 'FW reflash',
      width: "150",
      // flex: 1,
      renderCell: ({ row }) => (<div>{convertDateToString(row.date_reflash)}</div>)
    },
    {
      field: 'date_update', headerName: 'FW update',
      width: "150",
      // flex: 1,
      renderCell: ({ row }) => (<div>{convertDateToString(row.date_update)}</div>)
    },
    {
      field: 'version', headerName: 'FW version',
      width: "80",
      // flex: 1,
    },
    {
      field: 'type_str', headerName: 'FW type1',
      width: "250",
      // flex: 1,
    },
    {
      field: 'type_id', headerName: 'FW type2',
      width: "130",
      // flex: 1,
      renderCell: ({ row }) => (<div>{firmwares.find(firmware => firmware.id === row.type_id).controller}</div>)
    },
    {
      field: 'mac_factory', headerName: 'MAC factory',
      width: "150",
      // flex: 1,
    },
    {
      field: 'mac_custom', headerName: 'MAC custom',
      width: "150",
      // flex: 1,
    }, {
      field: 'msg_count', headerName: 'Messages',
      width: "100",
      hidden: true,
      sortComparator: (v1, v2) => v1 - v2, // Ensure sorting is numeric
      renderCell: ({ row }) => {
        if (row.msg_devices_push) {
          const waiting = row?.msg_devices_push.filter(msg => msg.date_viewed != null).length;
          const sent = row?.msg_devices_push.length;
          const allNotRead = waiting < sent; // Check if there are any unread messages
          let color = 'inherit'

          if (allNotRead) {
            color = 'orange';
          } else if ((sent !== 0) && (waiting == sent)) {
            color = '#00BB00';
          }

          return (
            <div style={{ color: color }} onClick={() => { setSelectedDevice(row); handleOpenMsgViewModal(row) }}>
              {`${waiting}/${sent}`}
            </div>
          );
        } else {
          return <div>N/A</div>;
        }
      }
    }

  ];

  return (
    <div className={styles.Container} style={{ flex: "1" }}>
      <ToastContainer />

      <div className="row">

        {/* <div className="col-2">
          <button className="btn btn-outline-primary mb-2 float-left" onClick={() => { loadDevices() }}>Refresh</button>
        </div>
        <div className="col-10"></div> */}

        <DataGrid
          // autoHeight
          // // getRowHeight={() => 'auto'}

          getRowId={(row) => { return row.mac_custom ? row.mac_custom : "unused" }}

          processRowUpdate={processRowUpdate}
          onProcessRowUpdateError={handleProcessRowUpdateError}

          // disableVirtualization
          columnHeaderHeight={35}
          rowHeight={30}
          rows={devices}
          columns={columns}

          initialState={{
            sorting: { sortModel: devicesSortModel, },
            pagination: { paginationModel: devicesPaginationModel },
            columns: {
              columnVisibilityModel: {
                "comment": isAdmin,
                "msg_count": isAdmin || isPartner,
                "date_app_cnx": isAdmin || isPartner,
                "version_app": isAdmin || isPartner,
                "user_id": isAdmin || isPartner,
              },
            },
          }}
          onSortModelChange={handleSortModelChange}

          pageSizeOptions={[25, 30, 35, 40, 45, 50, 55, 60, 100]}
          onPaginationModelChange={handlePaginationModelChange}

          slots={{ toolbar: TableToolbar }}
          slotProps={{
            toolbar: {
              showQuickFilter: true,
              quickFilterProps: { debounceMs: 500 },
            },
          }}
          sx={gridSxStyle}
        />

        {isModalSettingsOpen &&
          <DeviceModalSettings
            isOpen={isModalSettingsOpen}
            isAdmin={isAdmin}
            onRequestClose={handleCloseSettingsModal}
            deviceProps={selectedDevice}
          />
        }

        {((isAdmin || isPartner) && isModalLogsOpen) &&
          <DeviceModalLogs
            isOpen={isModalLogsOpen}
            isAdmin={isAdmin}
            onRequestClose={handleCloseLogsModal}
            deviceProps={selectedDevice}
            isDesktop={isDesktop}
          />
        }

        {((isAdmin || isPartner) && isModalMsgViewOpen) &&
          <DeviceModalMessageView
            isOpen={isModalMsgViewOpen}
            onRequestClose={() => setModalMsgViewOpen(false)}
            selectedDevice={selectedDevice}
            isAdmin={isAdmin}
            isPartner={isPartner}
            onMessageDelete={onMessageDelete}
            onUpdateDeviceMsgs={onUpdateDeviceMsgs}
          />
        }

      </div >
    </div >
  );
};

export default BoardDevices;
